import useSWR from 'swr';

const { REACT_APP_API_BASE_URL } = process.env;

const useUserOrgs = (user_id: string) => {
  const url = `${REACT_APP_API_BASE_URL}/users/${user_id}/organizations`;
  const { data, error, isLoading, mutate } = useSWR(encodeURI(url));

  return {
    orgs: data,
    error,
    isLoading,
    mutate,
  };
};

export default useUserOrgs;
